import { atom } from "recoil";

export const achievementAddModalStore = atom({
	key: "achievementAddModalStore",
	default: {
		show: false,
		loaded: true,
		name: "",
		description: "",
		category_id: null,
		currentOption: {
			achivType: [
				{ value: "deposit", label: "Deposit" },
				{ value: "withdrawal", label: "Withdrawal" },
				{ value: "verified", label: "Verified" },
				{ value: "spins", label: "Spins" },
				{ value: "vip_lvl", label: "Vip lvl" },
				{ value: "mobile_application", label: "Mobile application" },
				{ value: "referral", label: "Referral" },
				{ value: "email", label: "Email verified" },
				{ value: "phone", label: "Phone verified" },
				{ value: "tg", label: "Telegram verified" },
				{ value: "tasks", label: "Tasks" },
			],
		},
		startDate: null,
		endDate: null,
		type: "",
		rewardValue: "",
		rewardType: "",
		gameSpinsSelected: null,
		providerSpinsSelected: null,
		providerSelected: null,
		availableGames: [],
		gameSpinsAmount: 0,
		nameTranslationType: "",
		descriptionTranslationType: "",
		buttonTranslationType: "",
		gameSelected: null,
		betAmount: "",
		expiresAt: "",
		chestRewards: [],
		chestType: "",
		chestPrizeId: null,
		chestPrizeSelected: null,
		chestPrizeOptions: [],
		chestPrizeLoading: false,
		chestPrizeMatchMissing: false,
		image: null,
		cycle: null,
		cycleUnit: null,
		cycleTimer: null,
		buttonText: "",
		link: "",
		active: "",
		categories: [],
		count: "",
	},
});
